import { Button, Dropdown, Space, Tooltip } from 'antd';
import { EditIcon, EllipsisVertical, Trash } from 'lucide-react';
import React from 'react'
import { deleteModules, getModules } from '../../feature/modules/moduleSlice';
import { useDispatch } from 'react-redux';
import EditModule from './EditModule';
import EditRelationType from '../relation/EditRelationType';
import { deleteRelationType, getRelationType } from '../../feature/relation/RelationTypeSlice';
import EditCategory from '../category/EditCategory';
import { deleteCategory, getCategory } from '../../feature/category/CategorySlice';
import { categoryTypes } from '../../constant/Constatnt';

function ModuleAction({ types, moduleId, editData }) {
    const dispatch = useDispatch()


    const handleDeleteRelation = async () => {
        const resultAction = await dispatch(deleteRelationType(editData?._id));
        if (deleteRelationType.fulfilled.match(resultAction)) {
            await dispatch(getRelationType({}));
        } else {
            console.error("delete modules");
        }
    };


    const handleDeleteCategory = async () => {
        const resultAction = await dispatch(deleteCategory(editData?._id));
        if (deleteCategory.fulfilled.match(resultAction)) {
            await dispatch(getCategory({ types: categoryTypes[0] }));
        } else {
            console.error("delete category");
        }
    };



    const items = [
        {
            label: (
                <Space>
                    {types === "relation" ? <EditRelationType editData={editData} /> : types === "category" ? <EditCategory editData={editData} /> : <EditModule editData={editData} />}

                </Space>
            ),
            key: '0',
        },
        {
            label: (
                <Space onClick={types === "relation" ? handleDeleteRelation : handleDeleteCategory}>
                    <Tooltip title="Delete">
                        <Trash size={20} />
                    </Tooltip>

                </Space>
            ),
            key: '1',
        },


    ];
    return (
        <div>
            <Dropdown menu={{ items }} trigger={['click']}>
                <Button className='option_btn' icon={<EllipsisVertical size={15} />} shape='circle' onClick={e => e.preventDefault()}></Button>
            </Dropdown>
        </div>
    )
}

export default ModuleAction